export default function getResource(label, vars = []) {
    const resources = {
        errorDescriptionLine1: 'Désolé, la page que vous cherchez est introuvable.',
        errorDescriptionLine2: 'Découvrez des essentiels beauté chez Sephora entretemps.',
        ctaText: 'Magasiner'
    };

    return resources[label];
}
